import Service, { service } from '@ember/service';

import { query } from '@ember-data/legacy-compat/builders';

export default class ProductionScheduleRepoService extends Service {
  @service store;

  async getCurrent(station) {
    if (!station.productionScheduleEnabled) {
      return;
    }

    const {
      content: productionSchedules,
    } = await this.store.request(query('production-schedule', {
      stationId: station.id,
      isCompleted: false,
      includePartCounts: true,
      take: 1,
    }));

    return productionSchedules[0];
  }
}
